/**
 * Generated by scripts/generate-brand-assets.mjs from the app's
 * src/components/brand/boGeometry.js - do not edit by hand; regenerate.
 * Bo's one-colour glyph (handle + bell, the plate knocked out).
 */
export const BO_GLYPH = {
  viewBox: '-67 -115 134 171',
  /** width / height - size the glyph by its height, like the app does. */
  aspect: 0.7836,
  handle: 'M-36 -36C-47 -82 -40 -101 0 -101C40 -101 47 -82 36 -36',
  handleWidth: 27,
  body: 'M-42 47A63 63 0 1 1 42 47Q0 56 -42 47ZM-12 14H12A7 7 0 0 1 19 21V32A7 7 0 0 1 12 39H-12A7 7 0 0 1 -19 32V21A7 7 0 0 1 -12 14Z',
};
